import React from 'react';
import styled, { css } from 'styled-components';
import { fontStyle, spacing } from '../../../theme/index';
import { Text, TextVariant } from '../../../text/index';
import { Tooltip } from '../../../parts/index';
export const Label = ({ children, toolTip, htmlFor, subHeader, width = 256, variant = TextVariant.Small, className, ...rest }) => {
    return (<Title className={className} htmlFor={htmlFor} width={width} {...rest}>
      <TitleWrap>
        <TitleText variant={variant}>{children}</TitleText>
        {toolTip && <Tooltip text={toolTip}/>}
      </TitleWrap>
      {subHeader && <Helper>{subHeader}</Helper>}
    </Title>);
};
export default Label;
const Title = styled.label `
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${spacing.space8};
  width: ${({ width }) => typeof width === 'number' ? `${width}px` : width};
`;
const TitleWrap = styled.div `
  display: flex;
  align-items: flex-end;
  flex-basis: 100%;
  margin: 0;
  position: relative;
`;
const TitleText = styled(Text) `
  margin: 0;
  margin-right: ${spacing.space8};

  ${({ variant }) => variant === 'small' &&
    css `
      line-height: ${spacing.space16};
    `}
`;
const Helper = styled.h6 `
  margin: 0;
  margin-top: ${spacing.space4};
  ${fontStyle.article.caption};
  line-height: ${spacing.space16};
  flex-basis: 100%;
`;
